<template>
  <div class="modal-sterilizare-instrument instrument-modal-window"
       cy="modal-sterilizare">
    <h2>
      {{ title }}
    </h2>

    <form @submit.prevent="handleSubmit">
      <label for="date">
        <span>
          Data:
        </span>
        <br>
        <input id="date"
               cy="date"
               type="date"
               v-model="data.date" />
      </label>

      <label for="cuva">
        <span>
          Cuva:
        </span>
        <br>
        <input id="cuva"
               cy="cuva"
               type="text"
               placeholder="cuva"
               @input="handleCuva">
      </label>

      <p cy="id-sterilizare">
        ID Sterilizare: {{ idSterilizare }}
      </p>

      <p v-if="error"
         class="red mtop8px">
        {{ error }}
      </p>

      <div class="actions-bar flex">
        <button type="button"
                cy="cancel"
                @click="handleCancel">
          Cancel
        </button>

        <button cy="save"
                class="print-btn mright12px flex align-center"
                type="button"
                @click="handlePrint">
          Print
          <svg class="mleft8px" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.039 15.386C4.59433 15.386 4.214 15.2277 3.898 14.911C3.582 14.5943 3.42367 14.2147 3.423 13.772V11.386H1.615C1.171 11.386 0.791 11.2277 0.475 10.911C0.159 10.5943 0.000666667 10.2143 0 9.771V6.001C0 5.43433 0.192333 4.95967 0.577 4.577C0.961667 4.193 1.436 4.001 2 4.001H14.846C15.4127 4.001 15.8877 4.193 16.271 4.577C16.6543 4.961 16.846 5.43567 16.846 6.001V9.771C16.846 10.215 16.688 10.595 16.372 10.911C16.056 11.227 15.6757 11.3853 15.231 11.386H13.423V13.771C13.423 14.215 13.2647 14.595 12.948 14.911C12.6313 15.227 12.2513 15.3853 11.808 15.386H5.039ZM1.615 10.386H3.423C3.449 9.964 3.61633 9.602 3.925 9.3C4.23367 8.99867 4.605 8.848 5.039 8.848H11.808C12.2413 8.848 12.6123 8.999 12.921 9.301C13.2297 9.60233 13.397 9.964 13.423 10.386H15.231C15.4103 10.386 15.5577 10.3283 15.673 10.213C15.7883 10.0977 15.846 9.95033 15.846 9.771V6.001C15.846 5.71833 15.7503 5.481 15.559 5.289C15.3677 5.097 15.13 5.001 14.846 5.001H2C1.71667 5.001 1.47933 5.097 1.288 5.289C1.09667 5.481 1.00067 5.71867 1 6.002V9.771C1 9.95033 1.05767 10.0977 1.173 10.213C1.28833 10.3283 1.43567 10.386 1.615 10.386ZM12.423 4.002V1.616C12.423 1.436 12.3653 1.28867 12.25 1.174C12.1347 1.05867 11.9873 1.001 11.808 1.001H5.038C4.85867 1.001 4.71133 1.05867 4.596 1.174C4.48067 1.28933 4.423 1.43667 4.423 1.616V4.001H3.423V1.616C3.423 1.172 3.58133 0.791667 3.898 0.475C4.214 0.158334 4.594 0 5.038 0H11.808C12.252 0 12.632 0.158334 12.948 0.475C13.2647 0.791667 13.423 1.17167 13.423 1.615V4.001L12.423 4.002ZM14.039 7.502C14.3223 7.502 14.5597 7.406 14.751 7.214C14.9423 7.022 15.0383 6.78467 15.039 6.502C15.0397 6.21933 14.9437 5.98167 14.751 5.789C14.5583 5.59633 14.321 5.50033 14.039 5.501C13.757 5.50167 13.5193 5.59767 13.326 5.789C13.1327 5.98033 13.037 6.218 13.039 6.502C13.041 6.786 13.1367 7.02333 13.326 7.214C13.5153 7.40467 13.753 7.50067 14.039 7.502ZM12.423 13.77V10.463C12.423 10.283 12.3653 10.1353 12.25 10.02C12.1347 9.90467 11.9873 9.847 11.808 9.847H5.038C4.85867 9.847 4.71133 9.90467 4.596 10.02C4.48067 10.136 4.423 10.2837 4.423 10.463V13.771C4.423 13.9503 4.48067 14.0977 4.596 14.213C4.71133 14.3283 4.859 14.386 5.039 14.386H11.808C11.9873 14.386 12.1347 14.3283 12.25 14.213C12.3653 14.0977 12.423 13.95 12.423 13.77ZM1.615 5.002H1H15.846H1.615Z" fill="white"/>
          </svg>
        </button>

        <button cy="save">
          Save
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: 'ModalSterilizareInstrument',
    props: {
      title: String
    },
    data () {
      return {
        data: {
          date: new Date().toISOString().split('T')[0]
        }
      }
    },
    created () {
      this.$store.dispatch('get_new_id_sterilizare');
    },
    computed: {
      ...mapState({
        idSterilizare: state => state.sterilizare.idSterilizare,
        error: state => state.sterilizare.error,
      })
    },
    methods: {
      handlePrint () {
        this.$store.commit('SET_KEY_VALUE', {
          key: 'printComponentName',
          value: 'PrintEtichetaIDSterilizare'
        })
        setTimeout(() => {
          window.print();
          this.$emit('submit', { ...this.data, id_sterilizare: this.idSterilizare });
        }, 100)
      },
      handleCuva (ev) {
        this.data.cuva = ev.target.value;
      },
      handleCancel () {
        this.$emit('close')
      },
      handleSubmit () {
        this.$emit('submit', { ...this.data, id_sterilizare: this.idSterilizare });
      },
    }
  }
</script>

<style lang="less">
  .modal-sterilizare-instrument {
    @media only screen and (min-width: 0) {
      font-size: 1.6rem;
      form {
        label {
          display: block;
        }
        .print-btn {
          background-color: #1d77af;
          color: white;
        }
      }
    }
  }
</style>
